const lengthRegex = /.{8,}/; // At least 8 characters in length
const lowercaseRegex = /[a-z]/; // At least one lowercase letter
const uppercaseRegex = /[A-Z]/; // At least one uppercase letter
const numberRegex = /[0-9]/; // At least one number

export { lengthRegex, lowercaseRegex, numberRegex, uppercaseRegex };
